export default __webpack_public_path__ + "static/media/cassieHarbourPic.0229ad23.png";